import { generateId } from '@freelancer/datastore/testing';
import { Enterprise } from '../enterprise/enterprise.model';
import { EnterpriseModel } from './enterprises.model';

export interface GenerateEnterpriseOptions {
  readonly id?: number;
  readonly internalName: string;
  readonly name: string;
  readonly seoUrl: string;
  readonly isTestEnterprise?: boolean;
  readonly dateCreated?: number;
}

export function generateEnterpriseObject({
  id,
  internalName,
  name,
  seoUrl,
  isTestEnterprise = false,
  dateCreated = Date.now(),
}: GenerateEnterpriseOptions): EnterpriseModel {
  return {
    id: id || generateId(),
    internalName,
    name,
    seoUrl,
    isTestEnterprise,
    dateCreated,
  };
}

export function generateEnterpriseObjects(
  enterpriseOptionsList: readonly GenerateEnterpriseOptions[],
): readonly EnterpriseModel[] {
  return enterpriseOptionsList.map(enterpriseOptions =>
    generateEnterpriseObject(enterpriseOptions),
  );
}

export function facebookEnterprise(): GenerateEnterpriseOptions {
  return {
    id: Enterprise.FACEBOOK,
    internalName: 'facebook',
    seoUrl: 'facebook',
    name: 'Facebook',
  };
}
